import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propFunc, } from '../../../../../helpers/custom-prop-types';
import ProfessionalUnitExperiencedIndustry from './ProfessionalUnitExperiencedIndustry';
const ProfessionalUnitExperiencedIndustries = (props) => {
    const { industryClasses, onClickAll } = props;
    if (!industryClasses.length) {
        return null;
    }
    return (_jsxs("section", Object.assign({ className: 'experienced_card experienced_industries' }, { children: [_jsxs("div", Object.assign({ className: 'card_header' }, { children: [_jsx("h4", Object.assign({ className: 'header_title' }, { children: "\u7D4C\u9A13\u696D\u754C" })), _jsx("button", Object.assign({ className: 'header_link link-text', onClick: onClickAll, type: 'button' }, { children: "\u3059\u3079\u3066\u306E\u7D4C\u9A13\u696D\u754C\u3092\u898B\u308B" }))] })), _jsx("ul", Object.assign({ className: 'industry_columns' }, { children: industryClasses.map((v) => (_jsx(ProfessionalUnitExperiencedIndustry, { industryClass: v }, v.id))) }))] })));
};
ProfessionalUnitExperiencedIndustries.propTypes = {
    industryClasses: propArrayShape().isRequired,
    onClickAll: propFunc().isRequired,
};
export default ProfessionalUnitExperiencedIndustries;
